import { AdsService } from 'api/ads/service';
import { useCallback } from 'react';

export const useAds = () => {
    const onGetAllAds = useCallback(async () => {
        try {
            const response = await AdsService.getInstance().findAll();
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    const onGetOneAds = useCallback(async (id: number) => {
        try {
            const response = await AdsService.getInstance().findOne(id);
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    return { onGetAllAds, onGetOneAds };
};
